import { DataCardRankingQuery } from '../types';

export const queryData: DataCardRankingQuery = {
  data: {
    getCardCompetitionRanking: {
        competitionId: '21',
        customCompetitionName: 'Serie A',
        rankingLink: 'https://dev.sport.sky.it/calcio/serie-a/classifica',
        groups: [
            {
                roundName: 'unico',
                teams: [
                    {
                        games: 26,
                        id: '126',
                        logoUrl: 'https://dev.static.sky.it/images/skysport/it/calcio/squadre/team_logo_126.png',
                        negativeLogoUrl: 'https://dev.static.sky.it/images/skysport/it/calcio/squadre/team_logo_128_negative.png',
                        points: 37,
                        position: 9,
                        teamName: 'Verona',
                        teamUrl: 'https://dev.sport.sky.it/calcio/squadre/hellas-verona/news',
                        trend: 'static',
                    },
                    {
                        games: 26,
                        id: '126',
                        logoUrl: 'https://dev.static.sky.it/images/skysport/it/calcio/squadre/team_logo_126.png',
                        negativeLogoUrl: null,
                        points: 37,
                        position: 9,
                        teamName: 'Verona',
                        teamUrl: 'https://dev.sport.sky.it/calcio/squadre/hellas-verona/news',
                        trend: 'static',
                    },
                ],
            },
        ],
        createdAt: undefined,
        updatedAt: undefined
    },
  },
};

export const queryDataNonLinear: DataCardRankingQuery = {
  data: {
    getCardCompetitionRanking: {
        competitionId: '5',
        customCompetitionName: 'Champions League',
        rankingLink: 'https://dev.sport.sky.it/calcio/champions-league/classifica',
        groups: [
            {
                roundName: 'A',
                teams: [
                    {
                        games: 26,
                        id: '110',
                        logoUrl: 'https://svilcms.static.sky.it/images/skysport/it/calcio/squadre/team_logo_126.png',
                        points: 37,
                        position: 9,
                        teamName: 'Inter',
                        teamUrl: 'https://svilcms.sport.sky.it/calcio/squadre/inter/news',
                        trend: 'static',
                    },
                ],
            },
            {
                roundName: 'B',
                teams: [
                    {
                        games: 26,
                        id: '126',
                        logoUrl: 'https://svilcms.static.sky.it/images/skysport/it/calcio/squadre/team_logo_126.png',
                        points: 37,
                        position: 9,
                        teamName: 'Verona',
                        teamUrl: 'https://svilcms.sport.sky.it/calcio/squadre/hellas-verona/news',
                        trend: 'static',
                    },
                ],
            },
        ],
        createdAt: undefined,
        updatedAt: undefined
    },
  },
};
